import axios from "axios";
import {userSegment} from "@/common/constants/userSegment";

const state = () => ({
    items: [],
    players: [],
    ruleTypes: [],
    totalCount: 0,
    playersTotalCount: 0,
    isBusy: false,
    editedRule: {
        [userSegment.gender]: false,
        [userSegment.country]: false,
        [userSegment.locale]: false,
        [userSegment.optIn]: false
    },
    editedCountryRule: {
        [userSegment.country]: false
    }
})

// getters
const getters = {
    isBusy: state => state.isBusy,
    items: state => state.items,
    players: state => state.players,
    totalCount: state => state.totalCount,
    playersTotalCount: state => state.playersTotalCount,
    getEditedRule: (state) => (key) => {
        return state.editedRule[key];
    },
    // getEditedCountryRule: (state) => (key) => {
    //     return state.editedCountryRule[key];
    // }
}

// mutations
const mutations = {
    setEditedRule(state, data) {
      state.editedRule[data.key] = data.value
    },
    setBusy(state, data) {
        state.isBusy = data;
    },
    setItems(state, data) {
        state.items = data;
    },
    setPlayers(state, data) {
      state.players = data;
    },
    setRuleTypes(state, data) {
        state.ruleTypes = data;
    },
    setIsBusy(state, data) {
        state.isBusy = data;
    },
    setTotalCount(state, data) {
        state.totalCount = data;
    },
    setPlayersTotalCount(state, data) {
        state.playersTotalCount = data;
    }
}

// actions
const actions = {
    getRuleTypes({commit}) {
        return new Promise((resolve, reject) => {
            axios.get(`/api/segment/rule-types`)
                .then(function (response) {
                    resolve(response);
                    commit('setRuleTypes', response.data.items);
                })
                .catch(error => {
                    reject(error);
                    console.log(error);
                });
        });
    },
    loadItems({commit}, data) {
        commit('setIsBusy', true);
        axios.get(`/api/segments?limit=${data.params.limit}&offset=${data.params.offset}${createFilterQuery(data.filters)}${data.sort}`)
            .then(function (response) {
                commit('setItems', response.data.items);
                commit('setTotalCount', response.data.totalCount);
                commit('setIsBusy', false);
            })
            .catch(error => {
                console.log(error);
            });
    },
    loadSegmentsByType(context, isStatic) {
        return new Promise((resolve, reject) => {
            axios.get(`/api/segments?&filters[isStatic][0][value]=${isStatic}&filters[isStatic][0][operator]=eq`)
                .then(function (resp) {
                    resolve(resp);
                })
                .catch(error => {
                    console.log(error);
                    reject(error);
                });
        });
    },
    loadSegmentPlayers({commit}, data) {
        commit('setIsBusy', true);
        axios.get(`/api/segment/${data.id}/players?limit=${data.params.limit}&offset=${data.params.offset}${createFilterQuery(data.filters)}${data.sort}`)
            .then(function (response) {
                commit('setPlayers', response.data.items);
                commit('setPlayersTotalCount', response.data.totalCount);
                commit('setIsBusy', false);
            })
            .catch(error => {
                console.log(error);
            });
    },
    getSegmentRules(context, id) {
        return new Promise((resolve, reject) => {
        axios.get(`/api/segment/${id}/rules`)
            .then(function (response) {
                resolve(response.data);
            })
            .catch(error => {
                console.log(error);
                reject(error);
            });
        })
    },
    updateSegmentRules(context, payload) {
        return new Promise((resolve, reject) => {
            axios.post(`/api/segment/${payload.id}/rules`, payload.data)
                .then(response => {
                    resolve(response.data);
                })
                .catch(error => {
                    console.log(error);
                    reject(error);
                });
        })
    },
    saveSegment(context, data) {
        return new Promise((resolve, reject) => {
            axios.post('/api/segment', data)
                .then((response) => {
                    resolve(response.data);
                })
                .catch(error => {
                    console.log(error);
                    reject(error);
                });
        })
    },
    changeSegmentName(context, data) {
        return new Promise((resolve, reject) => {
            axios.patch(`/api/segment/${data.id}`, { name: data.name })
                .then((response) => {
                    resolve(response.data);
                })
                .catch(error => {
                    console.log(error);
                    reject(error);
                });
        })
    },
    deleteSegment(context, data) {
        return new Promise((resolve, reject) => {
            axios.delete(`/api/segment/${data}`)
                .then((response) => {
                    resolve(response.data);
                })
                .catch(error => {
                    console.log(error);
                    reject(error);
                });
        })
    },
    async editRule(context, payload) {
        const response = await axios.patch(`/api/segment/rule/${payload.type}/${payload.id}`, payload.data);
        return response;
    },
    async deleteSegmentRule(context, id) {
        const response = await axios.delete(`/api/segment/rule/${id}`);
        return response;
    }
}

function createFilterQuery(query) {
    let filter = '';
    Object.keys(query).forEach(key => {
        filter += query[key];

        if (key === 'phone') {
            filter += '&filters[phone][0][operator]=like'
        }

        if (key === 'phrase') {
            filter += '&filters[phrase][0][operator]=like'
        }

    })
    return filter;
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
